module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"begin":"{name}が始まりました！","end":"{name}が終わりました。\\n獲得したアイテムは航海記録から確認できます。"},"en":{"begin":"{name} has just begun!","end":"{name} is over.\\nYou can see the items you\u0027ve earned from your voyage log."}}')
  delete Component.options._Ctor
}
